import React, { useEffect } from "react";

//Import Icon Images
import contactIcon from "../../../assets/images/contact-book.png";
import emailIcon from "../../../assets/images/email.png";
import locationIcon from "../../../assets/images/location.png";

//Import AOS
import AOS from "aos";
import "aos/dist/aos.css";

const ContactDetails = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: false,
      offset: 100, // Trigger when the element is 100px from the viewport
      delay: 200, // Whether animation should happen only once
    });
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 m-8 lg:m-16 gap-8">
      {/* Phone Number Section */}
      <div
        className="text-start bg-white px-12 md:px-6 lg:px-12 py-6 rounded"
        style={{ boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.2)" }}
        data-aos="flip-left"
      >
        <img src={contactIcon} alt="" className="w-14 h-14 my-4" />
        <h2 className="text-lg lg:text-2xl font-bold text-[#F26422] oxygen my-4">
          Contact Phone Number
        </h2>
        <p className="text-[#4D5756] text-sm md:text-base lg:text-xl my-2">
          <a href="tel:+918455957004">+91 91245 78108</a>
        </p>
        {/* <p className='text-[#4D5756] text-sm md:text-base lg:text-xl my-2'>
              <a href="tel:+918658297475">+91 86582 97475</a>
            </p> */}
      </div>

      {/* Email Address Section */}
      <div
        className="text-start bg-white px-12 md:px-6 lg:px-12 py-6 rounded-md"
        style={{ boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.2)" }}
        data-aos="fade-up"
      >
        <img src={emailIcon} alt="" className="w-14 h-14 my-4" />
        <h2 className="text-lg lg:text-2xl font-bold text-[#F26422] oxygen my-4">
          Our Email Address
        </h2>
        <p className="text-[#4D5756] text-sm md:text-base lg:text-xl my-2">
          <a href="mailto:web.bocket@gmail.com">
            support@drivesafesolutions.in
          </a>
        </p>
        {/* <p className="text-[#4D5756] text-sm md:text-base lg:text-xl my-2">
          <a href="mailto:hrwebbocket@gmail.com">hrwebbocket@gmail.com</a>
        </p> */}
      </div>

      {/* Location Section */}
      <div
        className="text-start bg-white px-12 md:px-6 lg:px-12 py-6 rounded-md"
        style={{ boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.2)" }}
        data-aos="flip-right"
      >
        <img src={locationIcon} alt="" className="w-14 h-14 my-4" />
        <h2 className="text-lg lg:text-2xl font-bold text-[#F26422] oxygen my-4">
          Our Location
        </h2>
        <p className="text-[#4D5756] capitalize text-sm md:text-base lg:text-lg my-2">
          Floor No: KHATA NO-88, <br />
          PLOT No-161, Betamalisasan, <br />
          Near HANUMAN TEMPLE, Antia, Jajpur, Odisha, 755023
        </p>
      </div>
    </div>
  );
};

export default ContactDetails;
